import CreatePartitionFeature from "./CreatePartitionFeature";
export default CreatePartitionFeature;
